<script lang="ts">
    import { location, content, navigation } from "./store"
    import Header from "./lib/components/Header.svelte"
    import UpperImage from "./lib/components/UpperImage.svelte"
    import type { MainPoint } from "../../types/global"
    import { loadMainpoints } from "./lib/functions/getMainpoints"
    import Content from "./lib/components/content/Content.svelte"
    import { loadSubpoits } from "./lib/functions/getSubpoints"
    import Footer from "./lib/components/Footer.svelte"
    import SubField from "./lib/components/content/subField.svelte"
    import { loadNavigation } from "./lib/functions/getNavigation"
    export let url = ""

    if (url) {
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? l[1] : "",
            hash: "",
            categoryPath: l[0].replace(/\/[^_\/]+_[^\/]+$/, ""),
            push: false,
            pop: false,
        }
    }

    async function getContent(): Promise<ContentObject> {
        let mainPoints = await loadMainpoints()
        let subPoints = await loadSubpoits()
        let navigation = await loadNavigation()
        $navigation = navigation
        const contentObj: ContentObject = {}
        mainPoints = mainPoints.sort((a, b) => a.sort - b.sort)
        mainPoints.forEach((mainPoint) => {
            // Find the corresponding sub points for each main point
            const correspondingSubpoints = mainPoint.Seiten.flatMap((seite) =>
                subPoints.filter((subPoint) => subPoint.id === seite.seite)
            )
            // Add main point and corresponding sub points to the content object
            contentObj[mainPoint.title] = [mainPoint, correspondingSubpoints]
            // Remove the matched sub points from the subPoints array
            subPoints = subPoints.filter((subPoint) => !mainPoint.Seiten.some((seite) => seite.seite === subPoint.id))
        })
        // If there are leftover sub points, add them to the "additional" key
        if (subPoints.length > 0) {
            contentObj["additional"] = [
                {
                    title: "",
                    Seiten: [],
                },
                subPoints,
            ]
        }
        $content = contentObj
        return
    }
    let contentObj = getContent()
</script>

<div class="pagewrapper">
    <Header />
    <UpperImage />
    {#await contentObj then test}
        <Content />

        {#each $content["additional"][1] as subPoint, i}
            <div id="rowNr--{i}" class="subPoint-footer">
                <SubField subPoint="{subPoint}" footer="{true}" rowI="{-1}" i="{i}" />
            </div>
        {/each}
    {/await}

    <Footer />
</div>

<style lang="less" global>
    @import "./lib/assets/css/main.less";
    @import "./lib/assets/css/variables.less";
    #appContainer {
        font-family: Arial;
        width: 100%;
        min-height: 100%;
    }
    .subPoint-footer {
        visibility: hidden;
        height: 0px;
        overflow: hidden;
    }
    .underlined {
        text-decoration: underline !important;
    }
    * {
        transition: all 600ms;
    }
    .pagewrapper {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        @media @mobile {
            font-size: @bodyfontsize;
            h2 {
                font-size: @headingfontsize_mobile;
                font-weight: 500;
            }
            h3 {
                font-size: @bodyfontsize;
                font-weight: bold;
            }
        }
        @media @tablet {
            font-size: @bodyfontsize_desktop;
            h2 {
                font-size: @headingfontsize_desktop;
            }
            h3 {
                font-size: @bodyfontsize_desktop;
                font-weight: bold;
            }
        }
    }
</style>
